export function Brand({ compact = false, homeHref = "/#top", label = "IranTradeReach home" }: { compact?: boolean; homeHref?: string; label?: string }) {
  return (
    <a className={`brand ${compact ? "brand--compact" : ""}`} href={homeHref} aria-label={label}>
      <img src="/brand/logo-reference-reversed.png" alt="IranTradeReach — Connecting Supply, Expanding Trade" width="545" height="89" />
    </a>
  );
}
